<template>
    <div>
        <div class="row h1 page-header">
            Event
        </div>

        <v-event-info :event-id="eventId"></v-event-info>

        <v-event-available-jobs-list :event-id="eventId"></v-event-available-jobs-list>
    </div>
</template>

<script>
    export default {
        props: [
            'eventId'
        ],

        data() {
            return {
            }
        },

        methods: {
        }
    }
</script>
